// extracted by mini-css-extract-plugin
export default {"subTitle":"sub-title_subTitle__j+xVc"};